export const getImgUrl = (url, img, size = "default", noCache = false) => {
  if (!img || !url) {
    throw new Error(`Invalid operation : getImgUrl (img: ${img}, settings.url: ${url})`);
  }
  let defaultPath = `${url}?Name=${img}&Size=${size}`;
  if (noCache) {
    return `${defaultPath}&v=${new Date().getTime()}`;
  }
  return defaultPath;

};
